/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ZapOff = [
  "svg",
  defaultAttributes,
  [
    ["polyline", { points: "12.41 6.75 13 2 10.57 4.92" }],
    ["polyline", { points: "18.57 12.91 21 10 15.66 10" }],
    ["polyline", { points: "8 8 3 14 12 14 11 22 16 16" }],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22" }]
  ]
];

export { ZapOff as default };
//# sourceMappingURL=zap-off.js.map
